window.ZabranzQuiz = window.ZabranzQuiz || {};

window.ZabranzQuiz.init = function(sectionId) {
  var root = document.getElementById(sectionId);
  if (!root || root.dataset.initialized === "true") return;

  root.dataset.initialized = "true";

  var products = {
    classic_host: {
      name: "The Classic Host",
      description: "Warm, social and timeless. Your match is the Poppy Seed & Sea Salt Straw.",
      url: "https://zabranz.co.uk/products/poppy-seed-sea-salt?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web",
      image: "https://zabranz.co.uk/cdn/shop/files/1765044693799.png?v=1765044841",
      tags: ["cheddar", "balanced", "social", "classic", "crowd"]
    },
    crowd_pleaser: {
      name: "The Crowd-Pleaser",
      description: "Bold, generous and made to impress. Your match is the Loaded Cheddar Straw.",
      url: "https://zabranz.co.uk/products/loaded-cheese?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web",
      image: "https://zabranz.co.uk/cdn/shop/files/1765049442220.png?v=1765049493",
      tags: ["cheddar", "bold", "social", "crowd", "rich"]
    },
    old_soul: {
      name: "The Old-Soul Sophisticate",
      description: "Refined and distinctive. Your match is the Caraway Cheddar Straw.",
      url: "https://zabranz.co.uk/products/carraway-seed?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web",
      image: "https://zabranz.co.uk/cdn/shop/files/CompleteCheeseStrawsPackageLifestyleImage3_2d32b77c-c22c-4ac4-ab27-4863f6cb9448.png?v=1765046714",
      tags: ["cheddar", "subtle", "refined", "classic", "savory"]
    },
    elegant_minimalist: {
      name: "The Elegant Minimalist",
      description: "Chic, calm and quietly confident. Your match is the Cheddar & Parmesan Sablé.",
      url: "https://zabranz.co.uk/products/cheddar-and-parmesan-sables?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web",
      image: "https://zabranz.co.uk/cdn/shop/files/1765049879024.png?v=1765050031",
      tags: ["cheddar", "subtle", "cozy", "refined", "classic"]
    },
    bold_conversationalist: {
      name: "The Bold Conversationalist",
      description: "Intense and unapologetic. Your match is the Blue Cheese Sablé.",
      url: "https://zabranz.co.uk/products/blue-cheese-sables-coming-soon?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web",
      image: "https://zabranz.co.uk/cdn/shop/files/1765049879024.png?v=1765050031",
      tags: ["blue", "bold", "refined", "rich"]
    },
    everyday_indulger: {
      name: "The Everyday Indulger",
      description: "Comforting and easy to love. Your match is The Nibble Box.",
      url: "https://zabranz.co.uk/products/the-nibble-box?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web",
      image: "https://zabranz.co.uk/cdn/shop/files/NewProductLifestyleImage7.png?v=1765051257",
      tags: ["cheddar", "balanced", "cozy", "easy", "crowd"]
    },
    smoky_charmer: {
      name: "The Smoky Charmer",
      description: "Deep, warm and unforgettable. Your match is Paprika, Garlic & Smoked Shropshire.",
      url: "https://zabranz.co.uk/products/after-hours-paprika-garlic-smoked-shropshire-biscuits-coming-soon?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web",
      image: "https://zabranz.co.uk/cdn/shop/files/ZabranzAfterHoursNO.3ComingSoon.png?v=1774721060",
      tags: ["smoky", "bold", "rich", "after_hours"]
    },
    mediterranean_escape: {
      name: "The Mediterranean Escape",
      description: "Joyful, vibrant and sun-kissed. Your match is Oregano, Sundried Tomato & Mature Cheddar.",
      url: "https://zabranz.co.uk/products/after-hours-oregano-sundried-tomato-mature-cheddar-biscuits-coming-soon?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web",
      image: "https://zabranz.co.uk/cdn/shop/files/ZabranzAfterHoursNO.2ComingSoon.jpg?v=1774725325",
      tags: ["herb", "fresh", "social", "after_hours", "savory"]
    },
    fresh_thinker: {
      name: "The Fresh Thinker",
      description: "Bright, modern and uplifting. Your match is Lemon, Thyme & Pecorino.",
      url: "https://zabranz.co.uk/products/after-hours-lemon-thyme-pecorino-biscuits-coming-soon?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web",
      image: "https://zabranz.co.uk/cdn/shop/files/ZabranzAfterHoursNO.1ComingSoon.png?v=1774721365",
      tags: ["herb", "fresh", "subtle", "refined", "after_hours"]
    },
    quiet_luxury: {
      name: "The Quiet Luxury",
      description: "Grounded, refined and understated. Your match is Rosemary, Black Pepper & Manchego.",
      url: "https://zabranz.co.uk/products/after-hours-rosemary-black-pepper-manchego-cheese-biscuits-coming-soon?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web",
      image: "https://zabranz.co.uk/cdn/shop/files/ZabranzAfterHoursNO.4ComingSoon_4a7bad42-1fde-4d41-a7d8-c0800594340c.png?v=1774725247",
      tags: ["herb", "subtle", "refined", "rich", "after_hours"]
    }
  };

  var questions = [
    {
      question: "What’s your go-to drink at a gathering?",
      answers: [
        { text: "Red wine", tags: ["refined", "rich", "bold"] },
        { text: "Beer", tags: ["bold", "social", "smoky", "crowd"] },
        { text: "Gin & tonic", tags: ["fresh", "herb", "subtle"] },
        { text: "Something easy and cold", tags: ["balanced", "cozy", "classic"] }
      ]
    },
    {
      question: "What kind of atmosphere do you gravitate towards?",
      answers: [
        { text: "Cozy night in", tags: ["cozy", "subtle", "easy"] },
        { text: "Small dinner party", tags: ["refined", "social", "classic"] },
        { text: "Big lively gathering", tags: ["bold", "social", "crowd"] },
        { text: "Slow sunset drinks", tags: ["fresh", "after_hours", "refined"] }
      ]
    },
    {
      question: "What’s your favourite cheese style?",
      answers: [
        { text: "Sharp cheddar", tags: ["cheddar"] },
        { text: "Creamy blue", tags: ["blue"] },
        { text: "Smoked cheese", tags: ["smoky"] },
        { text: "Herby / bright / fresh", tags: ["herb"] }
      ]
    },
    {
      question: "What sounds most like your ideal weekend?",
      answers: [
        { text: "Cooking or snacking at home", tags: ["cozy", "easy", "balanced"] },
        { text: "Trying somewhere beautiful for dinner", tags: ["refined", "rich"] },
        { text: "Hosting friends", tags: ["social", "crowd", "classic"] },
        { text: "A countryside walk then a drink later", tags: ["fresh", "subtle", "herb"] }
      ]
    },
    {
      question: "Which flavour profile pulls you in most?",
      answers: [
        { text: "Bold and intense", tags: ["bold", "rich"] },
        { text: "Subtle and elegant", tags: ["subtle", "refined"] },
        { text: "Smoky, savoury, adventurous", tags: ["smoky", "bold", "savory"] },
        { text: "Fresh, bright and balanced", tags: ["fresh", "balanced", "herb"] }
      ]
    }
  ];

  var currentQuestion = 0;
  var selectedAnswers = [];
  var cheesePreference = null;

  var introEl = root.querySelector(".zq-intro");
  var quizBodyEl = root.querySelector(".zq-quiz");
  var questionContainerEl = root.querySelector(".zq-question-container");
  var progressEl = root.querySelector(".zq-progress");
  var resultEl = root.querySelector(".zq-result");
  var startBtn = root.querySelector(".zq-start");

  function flattenTags() {
    var tags = [];
    for (var i = 0; i < selectedAnswers.length; i++) {
      tags = tags.concat(selectedAnswers[i]);
    }
    return tags;
  }

  function scoreProducts(allTags) {
    var scores = {};
    var key, i, tag, productTags, score;

    for (key in products) {
      if (products.hasOwnProperty(key)) {
        score = 0;
        productTags = products[key].tags;

        for (i = 0; i < productTags.length; i++) {
          tag = productTags[i];
          if (allTags.indexOf(tag) !== -1) {
            score += 2;
          }
        }

        if (cheesePreference && productTags.indexOf(cheesePreference) !== -1) {
          score += 4;
        }

        if (
          allTags.indexOf("after_hours") !== -1 &&
          productTags.indexOf("after_hours") !== -1
        ) {
          score += 1;
        }

        scores[key] = score;
      }
    }

    return scores;
  }

  function breakTie(tiedKeys, allTags) {
    var i, j, key, filtered, tag;
    var priorityTags = ["smoky", "blue", "herb", "cheddar", "bold", "subtle", "social", "cozy"];

    if (cheesePreference) {
      filtered = [];
      for (i = 0; i < tiedKeys.length; i++) {
        key = tiedKeys[i];
        if (products[key].tags.indexOf(cheesePreference) !== -1) {
          filtered.push(key);
        }
      }
      if (filtered.length === 1) return filtered[0];
      if (filtered.length > 1) tiedKeys = filtered;
    }

    for (i = 0; i < priorityTags.length; i++) {
      tag = priorityTags[i];
      if (allTags.indexOf(tag) !== -1) {
        filtered = [];
        for (j = 0; j < tiedKeys.length; j++) {
          key = tiedKeys[j];
          if (products[key].tags.indexOf(tag) !== -1) {
            filtered.push(key);
          }
        }
        if (filtered.length === 1) return filtered[0];
        if (filtered.length > 1) tiedKeys = filtered;
      }
    }

    return tiedKeys[0];
  }

  function showResult() {
    var allTags = flattenTags();
    var scores = scoreProducts(allTags);
    var maxScore = -1;
    var tiedKeys = [];
    var key;
    var winnerKey;
    var winner;
    var html;

    for (key in scores) {
      if (scores.hasOwnProperty(key)) {
        if (scores[key] > maxScore) {
          maxScore = scores[key];
        }
      }
    }

    for (key in scores) {
      if (scores.hasOwnProperty(key)) {
        if (scores[key] === maxScore) {
          tiedKeys.push(key);
        }
      }
    }

    winnerKey = tiedKeys.length > 1 ? breakTie(tiedKeys, allTags) : tiedKeys[0];
    winner = products[winnerKey];

    quizBodyEl.classList.add("hidden");
    resultEl.classList.remove("hidden");

    html = '';
    html += '<img class="zq-result-image" src="' + winner.image + '" alt="' + winner.name + '">';
    html += '<h3>' + winner.name + '</h3>';
    html += '<p>' + winner.description + '</p>';
    html += '<div class="zq-result-buttons">';
    html += '<a href="' + winner.url + '" class="zq-btn zq-btn-primary">Shop your match</a>';
    html += '<button type="button" class="zq-btn zq-btn-secondary zq-restart">Retake quiz</button>';
    html += '</div>';

    resultEl.innerHTML = html;

    var restartBtn = root.querySelector(".zq-restart");
    if (restartBtn) {
      restartBtn.addEventListener("click", startQuiz);
    }
  }

  function renderQuestion() {
    var q = questions[currentQuestion];
    var html = '';
    var i;

    progressEl.textContent = "Question " + (currentQuestion + 1) + " of " + questions.length;

    html += '<div class="zq-question">';
    html += '<h3 class="zq-question-title">' + q.question + '</h3>';
    html += '<div class="zq-answers">';

    for (i = 0; i < q.answers.length; i++) {
      html += '<button type="button" class="zq-answer" data-index="' + i + '">' + q.answers[i].text + '</button>';
    }

    html += '</div>';
    html += '</div>';

    questionContainerEl.innerHTML = html;

    var buttons = root.querySelectorAll(".zq-answer");
    for (i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", function() {
        var answerIndex = Number(this.getAttribute("data-index"));
        var chosen = q.answers[answerIndex];

        selectedAnswers.push(chosen.tags);

        if (currentQuestion === 2) {
          if (chosen.tags.indexOf("cheddar") !== -1) cheesePreference = "cheddar";
          if (chosen.tags.indexOf("blue") !== -1) cheesePreference = "blue";
          if (chosen.tags.indexOf("smoky") !== -1) cheesePreference = "smoky";
          if (chosen.tags.indexOf("herb") !== -1) cheesePreference = "herb";
        }

        currentQuestion += 1;

        if (currentQuestion < questions.length) {
          renderQuestion();
        } else {
          showResult();
        }
      });
    }
  }

  function startQuiz() {
    currentQuestion = 0;
    selectedAnswers = [];
    cheesePreference = null;

    resultEl.classList.add("hidden");
    introEl.classList.add("hidden");
    quizBodyEl.classList.remove("hidden");

    renderQuestion();
  }

  if (startBtn) {
    startBtn.addEventListener("click", startQuiz);
  }
};

document.addEventListener("DOMContentLoaded", function() {
  var quizSections = document.querySelectorAll('[id^="zabranz-quiz-"]');
  for (var i = 0; i < quizSections.length; i++) {
    window.ZabranzQuiz.init(quizSections[i].id);
  }
});

document.addEventListener("shopify:section:load", function(event) {
  var el = event.target.querySelector('[id^="zabranz-quiz-"]');
  if (el) {
    window.ZabranzQuiz.init(el.id);
  }
});